<template>
  <span style="text-align:left;">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <quill-editor
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
      >
      </quill-editor>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <div class="quill-editor">
        <div class="ql-container">
          <div
            class="ql-editor"
            :class="{ 'text-xs-left': modo == 'list' }"
            v-html="displayvalue ? displayvalue : ''"
          ></div>
        </div>
      </div>
    </template>

    <template v-if="modo == 'filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="event => $emit('input', preUpdateFiltro(event))"
      ></v-text-field>
    </template>
  </span>
</template>

<script>
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor, Quill } from "vue-quill-editor";
window.Quill = Quill;

const ImageResize = require("quill-image-resize-module");
Quill.register("modules/imageResize", ImageResize.default);

import { ImageUpload } from "quill-image-upload";
Quill.register("modules/imageUpload", ImageUpload);

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      editorOption: {
        modules: {
          imageResize: {
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },

          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"]
          ] /*
            syntax: {
              highlight: text => hljs.highlightAuto(text).value
            },*/,
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageUpload: {
            url: global.config.endpoint + "/admin/upload/editor/upload", // server url
            method: "POST", // change query method, default 'POST'
            headers: {}, // add custom headers, example { token: 'your-token'}
            // personalize successful callback and call next function to insert new url to the editor
            callbackOK: (serverResponse, next) => {
              next(
                global.config.endpoint +
                  `/admin/content/arquivo/` +
                  serverResponse.file_path
              );
            },
            // personalize failed callback
            callbackKO: serverError => {
              alert("Erro no upload!");
            },
            // optional
            // add callback when a image have been chosen
            checkBeforeSend: (file, next) => {
              next(file); // go back to component and send to the server
            }
          }
        }
      }
    };
  },
  methods: {
    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
    preLoadFiltro(myval) {
      return myval;
    },
    preUpdateFiltro(myval) {
      return myval;
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    }
  },
  components: {
    quillEditor
  }
};
</script>

<style scoped></style>
